import React, {useContext, useEffect, useState} from 'react'
import {Button} from 'antd'
import {sideMenuContext} from "../../../router/IndexRouter";
import SearchMemberModal from "../common/SearchMemberModal";
import {Arguments} from "../common/Arguments";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import {SortByMemberPost} from "../common/SortListByPost";
import "../../../components/sandbox/index.css"


export default function MeetingDetail(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {meetingNotice} = useContext(sideMenuContext);
    const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/policy/api!meetingMember.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi]);

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '社会组织',
            dataIndex: 'organization_name',
            width: 180
        },
        {
            title: '姓名',
            dataIndex: 'member_name',
            width: 100,
            sorter: (a, b) => a.member_name.localeCompare(b.member_name),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '性别',
            dataIndex: 'member_sex',
            width: 80,
        },
        {
            title: "出生日期",
            dataIndex: 'member_born',
            width: 120,
        },
        {
            title: "民族",
            dataIndex: 'member_mz',
            width: 80,
        },
        {
            title: "政治面貌",
            dataIndex: 'member_zzmm',
            width: 100,
        },
        {
            title: "文化程度",
            dataIndex: 'member_educational',
            width: 100,
        },
        {
            title: "社团职务",
            dataIndex: 'member_post',
            width: 140,
        },
        {
            title: "工作单位（或原单位）",
            dataIndex: 'member_unit',
            width: 180,
        },
        {
            title: "职务",
            dataIndex: 'organization_post',
            width: 100,
        },
        {
            title: "职称",
            dataIndex: 'member_professional',
            width: 100,
        },
        {
            title: "身份证号",
            dataIndex: 'member_sfz'
        },
        {
            title: "手机号",
            dataIndex: 'mobile_phone'
        }
    ];

    // 筛选出当前 organizationId 下属于本次会议（meetingId）的数据
    const regEx = /\/(\d+)$/;
    const match = window.location.href.match(regEx);
    const meetingId = match ? match[1] : null;
    const filteredData = meetingId ? dataSource.filter(data => data.meeting_id === meetingId) : [];
    const indexDataSource = SortByMemberPost(filteredData).map((data, index) => ({showIndex: index + 1, ...data}))

    const showModal = () => {
        setIsModalOpen(true);
    };

    return (
        <>
            <div className="panel panel-default mt-20">
                <div className="panel-header">会议信息</div>
            </div>
            <h2 style={{textAlign: "center"}}><b>{meetingNotice?.title}</b></h2>
            <h3 style={{float: "right", marginRight: 20}}>通知日期: {meetingNotice?.publishDate}</h3>
            <br/>
            <h3><b>通知详情：</b></h3>
            <div style={{fontSize: 16}} dangerouslySetInnerHTML={{__html: meetingNotice?.meetingContent}}/>

            <div className="panel panel-default mt-20">
                <div className="panel-header">参会人员信息</div>
                <br></br>
            </div>
            <Button type="primary" onClick={() => showModal()} style={{marginBottom: 10}}>新增</Button>
            <SearchMemberModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                titleText="请选择参会人员"
                searchApi={Arguments.host + "/society_organization/society/api!memberPersonal.do"}
            />
            <Button htmlType="button" type="danger" onClick={() => {
                window.history.back()
            }} style={{marginLeft: 8}}>返回</Button>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}
